// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1tgUc","detailsBorder":"styles_detailsBorder__2x9_4"};